// React Dependencies
import React from 'react';

// Internal Dependencies
import POITable from './table';
import MText from '../common/MText';
import MButton from '../common/MButton';
import Colours from '../../styles/colours';

const POIList = () => (
  <div>
    <div className="content-header">
      <MText variant="h1" text="POIs" bold colour={Colours.Gray6} />
      <MButton variant="contained" text="ADD" colour={Colours.Gray3} onClick={() => { window.location.href = '/admin/poi/add'; }} />
    </div>

    <MButton
      variant="contained"
      text="Manage Popular Tags"
      colour={Colours.MaterialBlue}
      textColour={Colours.White}
      style={{ marginBottom: 18, textTransform: 'allcaps' }}
      onClick={() => {
        window.location.href = '/admin/pois/popular-tags';
      }}
    />

    <POITable />
  </div>
);

export default POIList;
